// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__qd5YJ","errors":"Errors_errors__2aEjd"};